import React from "react";

type MemberProfileEditSectionProps = {
  title: string;
  /** Optional anchor for skip links / in-page navigation */
  id?: string;
  /** Extra classes for the title row (same idea as {@link StickyCard} `titleClassName`). */
  titleClassName?: string;
  children: React.ReactNode;
};

/**
 * Same chrome as Manage Firm → Professionals → Edit ({@link StickyCard}: colored sticky bar + white title),
 * using brand red (`bg-primary`) instead of staff blue (`bg-secondary`).
 */
const MemberProfileEditSection: React.FC<MemberProfileEditSectionProps> = ({
  title,
  id,
  titleClassName,
  children,
}) => {
  const headingId = id ? `${id}-heading` : undefined;
  return (
    <section
      id={id}
      className="scroll-mt-20 sm:scroll-mt-24 flex w-full min-w-0 flex-col bg-white shadow-sm"
      aria-labelledby={headingId}
    >
      <div className="sticky top-0 z-10 flex items-center justify-between bg-primary shadow-md">
        <h2
          id={headingId}
          className={`${titleClassName ?? ""} break-words px-5 py-3 font-decimal text-lg font-medium text-white md:py-4 md:text-xl lg:text-2xl`}
        >
          {title}
        </h2>
      </div>
      <div className="w-full max-w-full min-w-0 px-5 py-6 md:px-8 md:py-8">
        <div className="min-w-0">{children}</div>
      </div>
    </section>
  );
};

export default MemberProfileEditSection;
